export enum FSEvent {
  OpenItemDetails = 'OpenItemDetails',
  UpdateItemStatus = 'UpdateItemStatus',
  SlideoutThreeDots = 'SlideoutThreeDots',
  DeleteComment = 'DeleteComment',
  UpdateComment = 'UpdateComment',
  CreateComment = 'CreateComment',
  AddItem = 'AddItem',
  LightUpdate = 'LightUpdate',
  UNI = 'UNI',
  ProjectDerivatives = 'ProjectDerivatives',
  Export = 'Export',
  VisitView = 'VisitView',
  Search = 'Search',
  AddedOrRemovedFromThePlan = 'AddedOrRemovedFromThePlan',
  ViewContentMetrics = 'ViewContentMetrics',
  DemandSensingResources = 'DemandSensingResources',
  DemandSensingResourcesLink = 'DemandSensingResourcesLink',
  EditModeEntered = 'EditModeEntered',
  MakePrimaryClicked = 'MakePrimaryClicked'
}
